export default "__VITE_ASSET__qe9BhtSL__"